export const MODE_VIEW = 'VIEW';
export const MODE_EDIT = 'EDIT';

export const GALLERY_ITEM_PHOTO = 'PHOTO';
export const GALLERY_ITEM_VIDEO = 'VIDEO';
